import { useEffect, useState } from 'react';
import LineWaves from '@/components/feature/LineWaves/LineWaves';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="relative min-h-screen w-full bg-[#05060a] text-white overflow-hidden" style={{ fontFamily: '"Inter", "Helvetica Neue", system-ui, sans-serif' }}>
      {/* Hero section */}
      <section className="relative w-full h-screen min-h-[720px] overflow-hidden">
        {/* Animated waves background */}
        <div className="absolute inset-0 z-0">
          <LineWaves
            speed={0.35}
            innerLineCount={32}
            outerLineCount={36}
            warpIntensity={1.1}
            rotation={-45}
            edgeFadeWidth={0.0}
            colorCycleSpeed={1.0}
            brightness={0.28}
            color1="#7df9ff"
            color2="#ff5ea8"
            color3="#ffd166"
            enableMouseInteraction={true}
            mouseInfluence={2.0}
          />
        </div>

        {/* Vignette overlay */}
        <div className="pointer-events-none absolute inset-0 z-10 bg-[radial-gradient(ellipse_at_center,_rgba(5,6,10,0)_0%,_rgba(5,6,10,0.4)_60%,_rgba(5,6,10,0.95)_100%)]" />
        {/* Soft dark gradient top + bottom */}
        <div className="pointer-events-none absolute inset-0 z-10 bg-gradient-to-b from-black/40 via-transparent to-black/70" />

        {/* Navbar */}
        <nav
          className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
            scrolled
              ? 'bg-[#05060a]/80 backdrop-blur-xl border-b border-white/5'
              : 'bg-transparent'
          }`}
        >
          <div className="w-full px-8 lg:px-14 h-20 flex items-center justify-between">
            <a href="#" className="text-[15px] font-semibold tracking-tight cursor-pointer whitespace-nowrap">
              Lumenwave
            </a>

            <div className="hidden md:flex items-center gap-9 text-[13.5px] text-white/70">
              <a href="#features" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Product</a>
              <a href="#use-cases" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Use cases</a>
              <a href="#stats" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Customers</a>
              <a href="#pricing" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Pricing</a>
              <a href="#docs" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Docs</a>
            </div>

            <div className="flex items-center gap-3">
              <a href="#" className="hidden sm:inline-flex text-[13.5px] text-white/80 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Sign in
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-1.5 px-4 h-9 rounded-full bg-white text-black text-[13px] font-medium hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
              >
                Get started
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </div>
        </nav>

        {/* Hero content */}
        <div className="relative z-20 h-full w-full flex flex-col">
          <div className="flex-1 flex items-center justify-center px-6">
            <div className="w-full max-w-5xl text-center flex flex-col items-center">
              {/* Heading */}
              <h1 className="text-[44px] md:text-[68px] lg:text-[84px] leading-[0.95] font-semibold tracking-[-0.04em] text-white">
                Design at the
                <br />
                <span className="italic font-light text-white/90">speed of</span> light.
              </h1>

              <p className="mt-7 max-w-xl text-[15px] md:text-[16.5px] leading-relaxed text-white/65">
                A generative motion engine for the next era of interfaces. Build hypnotic visuals,
                reactive backgrounds, and shader-driven hero scenes — without writing a single line
                of GLSL.
              </p>

              {/* CTAs */}
              <div className="mt-10 flex flex-col sm:flex-row items-center gap-3">
                <a
                  href="#"
                  className="group inline-flex items-center gap-2 h-12 px-6 rounded-full bg-white text-black text-[14px] font-medium hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap"
                >
                  Start building free
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center transition-transform group-hover:translate-x-0.5" />
                </a>
                <a
                  href="#"
                  className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-white/8 border border-white/15 backdrop-blur-md text-white text-[14px] font-medium hover:bg-white/15 transition-all cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-line w-4 h-4 flex items-center justify-center" />
                  Watch the film · 2:14
                </a>
              </div>

            </div>
          </div>

        </div>
      </section>

    </div>
  );
}